import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";

import { useParams, useHistory } from "react-router-dom";

import { useEffect, useState } from "react";

import toast from "react-hot-toast";
import { PermissionsPage } from "../../../../util/permissionsPage";
import Title from "../../../../components/title";

import { useUserData } from "../../../../hooks/useUserData";
import { isEmptyObject } from "../../../../util/isEmptyObject";
import ErrorToastHandler from "../../../../util/ErrorToastHandler";
import candidates from "../../../../services/candidates";
import { Flex } from "../components/Flex";
import { Download } from "@mui/icons-material";
import { InfoMain } from "../components/InfoMain";

const PERFIL_MAP = [
  { label: "Águia",   img: "aguia.jpg"   },
  { label: "Tubarão", img: "tubarao.jpg" },
  { label: "Gato",    img: "gato.png"    },
  { label: "Lobo",    img: "lobo.png"    },
];
const ASSETS_BASE = "https://assets.aprincipalbb.com.br/vagas";

function getDominantPerfil(perfilData) {
  try {
    const arr = typeof perfilData === "string" ? JSON.parse(perfilData) : perfilData;
    if (!arr || !arr.length) return null;
    let max = -1, result = null;
    arr.forEach((item, i) => {
      const pct = Number(item.porcentagem);
      if (pct > max) { max = pct; result = PERFIL_MAP[i] || null; }
    });
    return result;
  } catch { return null; }
}

const ETAPA_OPTIONS = [
  { value: "1",  label: "Candidatura" },
  { value: "2",  label: "Triagem de Currículo" },
  { value: "3",  label: "Testes Psicológicos" },
  { value: "4",  label: "Prova de Conhecimento" },
  { value: "5",  label: "Dinâmica de Grupo" },
  { value: "6",  label: "Entrevista Dirigida" },
  { value: "7",  label: "Entrevista Livre" },
  { value: "8",  label: "Apresentação ao Gestor" },
  { value: "9",  label: "Exames Admissionais" },
  { value: "10", label: "Contratação" },
];
const STATUS_OPTIONS = ["Participando", "Eliminado", "Banco de Talentos", "Selecionado"];

export const Candidate = () => {
  const history = useHistory();
  const params = useParams();
  const [data, setData] = useState({});
  const { userData } = useUserData();

  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [etapa, setEtapa] = useState("");
  const [status, setStatus] = useState("");

  const getInfoVacancies = async () => {
    setIsLoading(true);
    try {
      const response = await candidates.get(params.idCandidate);
      setData(response.data);
      setEtapa(response.data.etapa ? String(response.data.etapa) : "");
      setStatus(response.data.status || "Participando");
    } catch (error) {
      new ErrorToastHandler(error).showErrorToast();
    } finally {
      setIsLoading(false);
    }
  };

  const goBackList = () =>
    history.push(`/rh/vagas/ver-candidatos/${params.id}`);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await candidates.updateCandidate(params.idCandidate, { etapa, status });
      toast.success("Candidato atualizado com sucesso");
    } catch (error) {
      new ErrorToastHandler(error).showErrorToast();
      setEtapa(data.etapa ? String(data.etapa) : "");
      setStatus(data.status || "");
    } finally {
      setIsSaving(false);
    }
  };

  const handleConfirmDelete = async () => {
    setIsDeleting(true);
    try {
      await candidates.delete(params.idCandidate);
      toast.success("Candidato excluído com sucesso");
      setOpenDeleteDialog(false);
      goBackList();
    } catch (error) {
      new ErrorToastHandler(error).showErrorToast();
    } finally {
      setIsDeleting(false);
    }
  };

  useEffect(() => {
    if (params?.idCandidate) {
      if (!isEmptyObject(userData)) {
        getInfoVacancies();
      }
    }
  }, [params?.idCandidate, userData]);

  return (
    <>
      {PermissionsPage("register_vacancies") && (
        <>
          <Box pl={2}>
            <Title title={`Informações do candidato`} />
          </Box>

          {isLoading ? (
            <Box width={"100%"} p={2}>
              <Box component={Paper} elevation={1} variant="outlined" p={2}>
                <Flex justifyContent={"space-between"}>
                  <Skeleton
                    variant="rounded"
                    sx={{ maxWidth: "300px" }}
                    height={35}
                    width={"100%"}
                  />
                  <Skeleton
                    variant="rounded"
                    sx={{ maxWidth: "150px" }}
                    height={35}
                    width={"100%"}
                  />
                </Flex>

                <Stack pt={2} mb={2} direction={"row"} gap={2}>
                  <Skeleton variant="rounded" height={55} width={"100%"} />
                  <Skeleton variant="rounded" height={55} width={"100%"} />
                  <Skeleton variant="rounded" height={55} width={"100%"} />
                  <Skeleton variant="rounded" height={55} width={"100%"} />
                </Stack>
                <Divider />
                <Stack pt={2} mb={2} direction={"row"} gap={2}>
                  <Skeleton variant="rounded" height={55} width={"100%"} />
                  <Skeleton variant="rounded" height={55} width={"100%"} />
                  <Skeleton variant="rounded" height={55} width={"100%"} />
                </Stack>
                <Divider />
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={70} />
                <Stack spacing={1.5} width={"100%"} justifyContent={"center"} direction={"row"}>
                  <Skeleton variant="rounded" height={55} width={150} />
                  <Skeleton variant="rounded" height={55} width={150} />
                  <Skeleton variant="rounded" height={55} width={150} />
                  <Skeleton variant="rounded" height={55} width={150} />
                </Stack>
              </Box>
            </Box>
          ) : (
            <Box sx={{ px: 2, paddingBottom: 3 }}>
              <>
                {!isLoading && (
                  <Box display={"flex"} gap={4} width={"100%"}>
                    <Paper sx={{ p: 2, flex: 1 }} variant="outlined" elevation={3}>
                      <Stack gap={1}>
                        <Flex width={"100%"} justifyContent={"space-between"} alignItems="center">
                          <Flex gap={2} alignItems="center">
                            {(() => {
                              const perfil = PERFIL_MAP[data.perfil_dominante] ?? getDominantPerfil(data.perfil);
                              return perfil ? (
                                <img
                                  src={`${ASSETS_BASE}/${perfil.img}`}
                                  alt={perfil.label}
                                  title={perfil.label}
                                  style={{ width: 64, height: 64, objectFit: "contain" }}
                                />
                              ) : null;
                            })()}
                            <Typography variant="h5" component={"h5"}>
                              {data.nome}
                            </Typography>
                          </Flex>
                          <Button
                            color="aprincipal"
                            variant="contained"
                            startIcon={<Download />}
                            component="a"
                            href={data.curriculo}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Baixar curriculo
                          </Button>
                        </Flex>
                        {etapa && (
                          <Box sx={{ width: "100%", mt: 1 }}>
                            <Box sx={{ position: "relative" }}>
                              <LinearProgress
                                variant="determinate"
                                value={Number(etapa) * 10}
                                sx={{
                                  height: 24,
                                  borderRadius: 1,
                                  backgroundColor: "#e0e0e0",
                                  "& .MuiLinearProgress-bar": {
                                    backgroundColor: "#ff7aae",
                                    borderRadius: 1,
                                  },
                                }}
                              />
                              <Typography
                                variant="caption"
                                sx={{
                                  position: "absolute",
                                  left: 8,
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  color: "#fff",
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                {Number(etapa) * 10}% de Progresso
                              </Typography>
                            </Box>
                          </Box>
                        )}
                        <InfoMain data={data} />
                      </Stack>

                      <Divider sx={{ my: 2 }} />

                      <Stack spacing={2}>
                        <Typography variant="subtitle1" fontWeight={600}>
                          Atualizar candidatura
                        </Typography>
                        <Stack direction="row" gap={2} flexWrap="wrap">
                          <FormControl sx={{ minWidth: 160 }} size="small">
                            <InputLabel>Fase no Processo</InputLabel>
                            <Select
                              value={etapa}
                              label="Fase no Processo"
                              onChange={(e) => setEtapa(e.target.value)}
                            >
                              {ETAPA_OPTIONS.map((opt) => (
                                <MenuItem key={opt.value} value={opt.value}>
                                  {opt.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <FormControl sx={{ minWidth: 200 }} size="small">
                            <InputLabel>Status do Participante</InputLabel>
                            <Select
                              value={status}
                              label="Status do Participante"
                              onChange={(e) => setStatus(e.target.value)}
                            >
                              {STATUS_OPTIONS.map((s) => (
                                <MenuItem key={s} value={s}>
                                  {s}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Stack>

                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} gap={2}>
                          <Button
                            variant="outlined"
                            color="error"
                            type="button"
                            onClick={() => setOpenDeleteDialog(true)}
                          >
                            Excluir Candidato
                          </Button>

                          <Box display="flex" gap={1}>
                            <Button
                              variant="outlined"
                              onClick={goBackList}
                              color="aprincipal"
                              type="button"
                            >
                              Voltar
                            </Button>
                            <Button
                              variant="contained"
                              color="aprincipal"
                              type="button"
                              onClick={handleSave}
                              disabled={isSaving}
                            >
                              {isSaving ? "Salvando..." : "Salvar"}
                            </Button>
                          </Box>
                        </Box>
                      </Stack>
                    </Paper>
                  </Box>
                )}
              </>
            </Box>
          )}

          <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
          >
            <DialogTitle>Excluir candidato</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Tem certeza que deseja excluir o candidato <strong>{data.nome}</strong>? Esta ação não pode ser desfeita.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenDeleteDialog(false)} color="inherit">
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmDelete}
                color="error"
                variant="contained"
                disabled={isDeleting}
              >
                {isDeleting ? "Excluindo..." : "Excluir"}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};
